import React, {Component} from "react";
import {connect} from "react-redux";
import SmartFlagsProfileList from "../../components/smart-flags/profile-list";
import {
  getSmartFlagProfiles,
  getSmartFlagProfileDetail,
  createSmartFlagProfile,
  updateSmartFlagProfile,
  deleteSmartFlagProfile,
  cloneSmartFlagProfile,
  setSmartFlagProfileDefault,
  resetSmartFlagProfileDetail
} from "../../redux/actions";

class SmartFlagsPage extends Component {
  componentDidMount() {
    const {profile, getSmartFlagProfiles} = this.props;
    getSmartFlagProfiles(profile.customerid);
  }

  refreshProfiles() {
    const {profile, getSmartFlagProfiles} = this.props;
    getSmartFlagProfiles(profile.customerid);
  }

  render() {
    const {translate, profiles, profileDetail, profile, impersonating, softwareUpdate} = this.props;

    return (
      <SmartFlagsProfileList
        translate={translate}
        profiles={profiles}
        profileDetail={profileDetail}
        organisationId={profile.customerid}
        impersonating={impersonating}
        softwareUpdate={softwareUpdate}
        getSmartFlagProfileDetail={this.props.getSmartFlagProfileDetail}
        createSmartFlagProfile={this.props.createSmartFlagProfile}
        updateSmartFlagProfile={this.props.updateSmartFlagProfile}
        deleteSmartFlagProfile={this.props.deleteSmartFlagProfile}
        cloneSmartFlagProfile={this.props.cloneSmartFlagProfile}
        setSmartFlagProfileDefault={this.props.setSmartFlagProfileDefault}
        resetSmartFlagProfileDetail={this.props.resetSmartFlagProfileDetail}
        refreshProfiles={() => this.refreshProfiles()}
      />
    );
  }
}

const mapStateToProps = state => ({
  profile: state.profileReducer.profile,
  profiles: state.smartFlagProfileReducer.profiles,
  profileDetail: state.smartFlagProfileReducer.profileDetail,
  impersonating: state.userReducer?.impersonating || false,
  softwareUpdate: state.userReducer?.softwareUpdate || false,
  ...state
});

const mapDispatchToProps = (dispatch, props) => ({
  getSmartFlagProfiles: (organisationId) => {
    dispatch(getSmartFlagProfiles(organisationId))
  },
  getSmartFlagProfileDetail: (id) => {
    dispatch(getSmartFlagProfileDetail(id))
  },
  createSmartFlagProfile: (data) => {
    return dispatch(createSmartFlagProfile(data))
  },
  updateSmartFlagProfile: (id, data) => {
    return dispatch(updateSmartFlagProfile(id, data))
  },
  deleteSmartFlagProfile: (id) => {
    return dispatch(deleteSmartFlagProfile(id))
  },
  cloneSmartFlagProfile: (sourceProfileId, newName) => {
    return dispatch(cloneSmartFlagProfile(sourceProfileId, newName))
  },
  setSmartFlagProfileDefault: (profileId, organisationId, isDefault) => {
    return dispatch(setSmartFlagProfileDefault(profileId, organisationId, isDefault))
  },
  resetSmartFlagProfileDetail: () => {
    dispatch(resetSmartFlagProfileDetail())
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SmartFlagsPage);
